// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Close = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M76.414 73.587a2 2 0 1 1-2.828 2.828L48 50.828 22.414 76.415A1.99 1.99 0 0 1 21 77a2 2 0 0 1-1.414-3.414L45.172 48 19.586 22.416a2 2 0 1 1 2.828-2.828L48 45.172l25.586-25.585a2 2 0 1 1 2.828 2.828L50.828 48l25.586 25.586Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default Close;
